export const startCheckersPositions = new Map([
    [0, 'a1'],
    [1, 'c1'],
    [2, 'e1'],
    [3, 'g1'],
    [4, 'b2'],
    [5, 'd2'],
    [6, 'f2'],
    [7, 'h2'],
    [8, 'a3'],
    [9, 'c3'],
    [10, 'e3'],
    [11, 'g3'],
    [12, 'h8'],
    [13, 'f8'],
    [14, 'd8'],
    [15, 'b8'],
    [16, 'g7'],
    [17, 'e7'],
    [18, 'c7'],
    [19, 'a7'],
    [20, 'h6'],
    [21, 'f6'],
    [22, 'd6'],
    [23, 'b6'],
]);
